<div [ngStyle]="{ 'z-index': zIndex }" class="relative h-[380px] mb-10 md:mb-8 mx-auto w-full max-w-7xl px-4 md:px-0">
  <div class="row-card" style=" margin: 0 -1rem;">
    <!-- Skeleton del encabezado (título + flechas) -->
    <div *ngIf="isSkeleton; else titleCarousel"
      class="card-skeleton pointer-events-none mb-4 pb-3 border-b border-gray-200 mx-4 ">

      <div class="skeleton-row items-center justify-between w-full">
        <!-- Título simulado -->
        <div class="skeleton-text short w-40 h-6 rounded-md"></div>

        <!-- Flechas simuladas -->
        <div class="flex space-x-2">
          <div class="skeleton-circle"></div>
          <div class="skeleton-circle"></div>
        </div>
      </div>
    </div>
    <!-- Encabezado del slider -->
    <ng-template #titleCarousel>
      <div class="flex justify-between items-start mt-4 mx-4 mb-2 ">
        <div>
          <h2 class="text-lg font-semibold">{{title}}</h2>
          <p *ngIf="subtitle" class="text-sm text-gray-500 mt-0.5">{{subtitle}}</p>
        </div>
        <div class="flex space-x-2" *ngIf="contents.length > 4">
          <!-- Flecha previa -->
          <button id="prevBtn" (click)="prev()"
            class="carousel-nav-btn flex h-8 w-8 items-center justify-center rounded-full bg-muted/80 shadow-sm transition-colors hover:bg-muted">
            <i class="icon text-sm leading-none icon-arrow-ios-left transition-colors"></i>
          </button>

          <!-- Flecha siguiente -->
          <button id="nextBtn" (click)="next()"
            class="carousel-nav-btn flex h-8 w-8 items-center justify-center rounded-full bg-muted/80 shadow-sm transition-colors hover:bg-muted">
            <i class="icon text-sm leading-none icon-arrow-ios-right transition-colors"></i>
          </button>
        </div>
      </div>
    </ng-template>

    <owl-carousel-o [options]="carouselOptions" #carousel>
      <ng-container *ngFor="let content of contents">
        <ng-template carouselSlide>
          <content-card [content]="content" [origin]="origin"></content-card>
        </ng-template>
      </ng-container>

      <!--contenido vacio < 1 cards-->
      <ng-container *ngFor="let _ of emptySlots">
        <ng-template carouselSlide>
          <div class="empty-slide"></div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</div>